export default "__VITE_ASSET__CfVyk16m__"